import { UNIPROMEL_THEME, OPENLEGAL_THEME, getThemeName } from "./themes"

export const BLUE_COLOUR = '#3238C4'
export const GRAY_COLOUR = '#8A8A8A'
export const GRAY_400_COLOUR = '#979797'
export const RED_COLOUR = '#FF7061'
export const WHITE_COLOUR = '#EEEEEE'
export const GREEN_COLOUR = '#6AEF89'
export const YELLOW_COLOUR = '#E8F053'
export const ORANGE_COLOUR = '#434B61'
export const BLUE_UNIPROMEL_COLOUR = '#0A3D62'
export const BACKGROUND_COLOUR = '#E4E4E4'
export const BLACK_COLOUR = '#212529'
export const SECONDARY = '#FFFFFF'
export const ORANGE_MID_COLOUR = '#F4B05A'
export const GREEN_LIGHT_COLOUR = '#A9F06E'
export const DARK_YELLOW_COLOUR = '#C5BB00'
export function getPrimaryColour () {
	return getThemeName() === UNIPROMEL_THEME ? BLUE_UNIPROMEL_COLOUR : (getThemeName() === OPENLEGAL_THEME ? ORANGE_COLOUR : BLUE_COLOUR)
}



// WEBPACK FOOTER //
// ./src/constants/colours.js